// src/subscreens/admin/addRawMaterial/AddRawMaterial.jsx
//
// Context removed — parent se onAdd prop pass karo
// RawMaterialsList mein: <AddRawMaterial isOpen onClose={...} onAdd={(m) => setRawMaterials(prev => [...prev, m])} />

import { useContext, useEffect, useState } from "react";
import Modal from "../../../components/admin/modal/ProductModel";
import "../../../assets/css/admin/addRawMaterial/AddRawMaterial.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const AddRawMaterial = ({ isOpen, onClose, triggerRefresh }) => {
  const { baseUrl, authToken } = useContext(AppContext);
  const [errors, setErrors] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [name, setName] = useState("");
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState("");

  const [currentStock, setCurrentStock] = useState("");
  const [minimumStock, setMinimumStock] = useState("");
  //const [reorderPoint, setReorderPoint] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [unit, setUnit] = useState("");
  const [supplier, setSupplier] = useState("");
  const [rawMaterials, setRawMaterials] = useState("");

  const viewAllCategories = ()=>
    {
      axios.get(`${baseUrl}/admin/category/viewCategories`, {
        headers : {
          Authorization: `Bearer${authToken}`
        },
        params : {'type' : "inventory"}
      })
      .then((response)=>{
        setCategories(response.data.categories)
      })
      .catch((error)=>{
        console.log(error);
      })
  }

    useEffect(() => {
  viewAllCategories();
}, []);
  

  const addInventory = () => {
    console.log("add inventory called");
    const formdata = new FormData();
    formdata.append("name", name);
    formdata.append("adcategory_id", category);
    formdata.append("currentStock", currentStock);
    formdata.append("minimumStock", minimumStock);
    formdata.append("unitPrice", unitPrice);
    formdata.append("unit", unit);
    formdata.append("supplier", supplier);
    axios
      .post(`${baseUrl}/admin/inventory/addInventory`, formdata, {
        headers: {
          Authorization: `Bearer${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data);
        triggerRefresh();
        setIsSaving(false);
        setShowSuccess(true);
      })
      .catch((error) => {
        console.log(error);
        setIsSaving(false);
      });
  };

  const validate = () => {
    const e = {};
    if (!name.trim()) e.name = "Material name is required";
    if (!category) e.category = "Category is required";
    if (!currentStock || currentStock < 0)
      e.currentStock = "Valid stock is required";
    if (!minimumStock || minimumStock < 0)
      e.minimumStock = "Valid minimum stock is required";
    if (!unitPrice || unitPrice <= 0) e.unitPrice = "Valid price is required";
    if (!unit.trim()) e.unit = "Unit is required";
    if (!supplier.trim()) e.supplier = "Supplier is required";
    return e;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setIsSaving(true);
    addInventory();
  };

  const handleClose = () => {
    if (!isSaving) {
      setErrors({});
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Add New Raw Material"
      size="large"
    >
      {showSuccess ? (
        <div className="inv-add-success">
          <div className="inv-add-success-icon">✓</div>
          <h3>Material Added Successfully!</h3>
          <p>The new raw material has been added to inventory.</p>
        </div>
      ) : (
        <form className="inv-add-form" onSubmit={handleSubmit}>
          <div className="inv-add-grid">
            <div className="inv-add-group inv-add-full">
              <label htmlFor="name">Material Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={(event) => {
                  setName(event.target.value);
                }}
                className={errors.name ? "inv-add-error" : ""}
                placeholder="e.g., Oak Wood Planks"
              />
              {errors.name && (
                <span className="inv-add-error-text">{errors.name}</span>
              )}
            </div>

            <div className="inv-add-group">
              <label htmlFor="category">Category *</label>
              <select
                id="category"
                name="category"
                value={category}
                onChange={(event) => {
                  setCategory(event.target.value);
                }}
                className={errors.category ? "inv-add-error" : ""}
              >
                <option value="">Select category</option>
                {categories.map((cat)=>(
                  <option key={cat.id} value={cat.id}> {cat.name}</option>
                ))}
              </select>
              {errors.category && (
                <span className="inv-add-error-text">{errors.category}</span>
              )}
            </div>

            <div className="inv-add-group">
              <label htmlFor="unit">Unit *</label>
              <input
                type="text"
                id="unit"
                name="unit"
                value={unit}
                onChange={(event) => {
                  setUnit(event.target.value);
                }}
                className={errors.unit ? "inv-add-error" : ""}
                placeholder="e.g., pcs, meters, kg"
              />
              {errors.unit && (
                <span className="inv-add-error-text">{errors.unit}</span>
              )}
            </div>

            <div className="inv-add-group">
              <label htmlFor="currentStock">Current Stock *</label>
              <input
                type="number"
                id="currentStock"
                name="currentStock"
                value={currentStock}
                onChange={(event) => {
                  setCurrentStock(event.target.value);
                }}
                className={errors.currentStock ? "inv-add-error" : ""}
                placeholder="500"
                min="0"
              />
              {errors.currentStock && (
                <span className="inv-add-error-text">
                  {errors.currentStock}
                </span>
              )}
            </div>

            <div className="inv-add-group">
              <label htmlFor="minimumStock">Minimum Stock *</label>
              <input
                type="number"
                id="minimumStock"
                name="minimumStock"
                value={minimumStock}
                onChange={(event) => {
                  setMinimumStock(event.target.value);
                }}
                className={errors.minimumStock ? "inv-add-error" : ""}
                placeholder="100"
                min="0"
              />
              {errors.minimumStock && (
                <span className="inv-add-error-text">
                  {errors.minimumStock}
                </span>
              )}
            </div>

            {/* <div className="inv-add-group">
              <label htmlFor="reorderPoint">Reorder Point *</label>
              <input
                type="number"
                id="reorderPoint"
                name="reorderPoint"
                value={reorderPoint}
                onChange={(event) => {
                  setReorderPoint(event.target.value)
                }}
                className={errors.reorderPoint ? "inv-add-error" : ""}
                placeholder="150"
                min="0"
              />
              {errors.reorderPoint && (
                <span className="inv-add-error-text">
                  {errors.reorderPoint}
                </span>
              )}
            </div> */}

            <div className="inv-add-group">
              <label htmlFor="unitPrice">Unit Price (PKR) *</label>
              <input
                type="number"
                id="unitPrice"
                name="unitPrice"
                value={unitPrice}
                onChange={(event) => {
                  setUnitPrice(event.target.value);
                }}
                className={errors.unitPrice ? "inv-add-error" : ""}
                placeholder="250"
                min="0"
              />
              {errors.unitPrice && (
                <span className="inv-add-error-text">{errors.unitPrice}</span>
              )}
            </div>

            <div className="inv-add-group inv-add-full">
              <label htmlFor="supplier">Supplier *</label>
              <input
                type="text"
                id="supplier"
                name="supplier"
                value={supplier}
                onChange={(event) => {
                  setSupplier(event.target.value);
                }}
                className={errors.supplier ? "inv-add-error" : ""}
                placeholder="e.g., Wood House Islamabad"
              />
              {errors.supplier && (
                <span className="inv-add-error-text">{errors.supplier}</span>
              )}
            </div>
          </div>

          <div className="inv-add-actions">
            <button
              type="button"
              className="inv-add-cancel"
              onClick={handleClose}
              disabled={isSaving}
            >
              Cancel
            </button>
            <button type="submit" className="inv-add-save" disabled={isSaving}>
              {isSaving ? "Adding Material..." : "Add Material"}
            </button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default AddRawMaterial;
